<div class="container-fluid">
  <div class="card">
    <!--<div class="card-header nocollapse">
      Create Question Description
    </div>-->
    <div class="card-header nocollapse">
      <b>Description Type Question</b>
    </div>
    <div [hidden]="folderId == -1">
      <div class="bg-info p-1 mb-3">
        <div class="row">
          <div class="col-md-10">
            <span class="text-white pt-2" style="font-size:18px; display:inline-block"><b>Folder Name : </b>{{ folderName }}</span>
          </div>
          <div class="col-md-2 py-1">
            <button type="button" class="btn btn-primary btn-action" (click)="BackToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-arrow-left"></i> Back to Section</button>
            <button type="button" class="btn btn-primary btn-action mb-0" (click)="BackUrl()"><i class="fa fa-home"></i> Home</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-header nocollapse bg-info col-md-12 " *ngIf="successOrFailureMessage!==''">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <b>{{successOrFailureMessage}}</b>
    </div>

    <div class="col-md-12 card-body">

      <form [formGroup]="questionDescriptionForm" #f="ngForm">
        <!--<small class="form-text text-muted invalid-control-message">
          Please Enter All Required Fields.
        </small>-->

        <div class="row mb-3">
          <label for="questionDescription" class="form-control-label col-md-2">Question Title </label>
          <div class="col-md-10"><textarea maxlength="1000" rows="8" cols="13" id="questionDescription" name="questionDescription" formControlName="questionDescription" class=" form-control" placeholder="Please Enter Question Title" #questionDescription></textarea></div>
        </div>

        <div class="row mb-3">
          <label class="form-control-label col-md-2" for="questionCategoryId"> Category</label>
          <div class="col-md-3">
            <select name="questionCategoryId" id="questionCategoryId" formControlName="questionCategoryId" class="form-control form-control custom-select-with-arrow">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of questionCategoryList" [ngValue]="item?.questionCategoryId" [selected]="questionCategoryId==item?.questionCategoryId">
                {{item.questionCategoryName}}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-primary btn-action"
                    (click)="openCategoryModal()">
              <i class="fa fa-plus"></i> Create Category
            </button>
          </div>
          <label class="col-md-1 form-control-label" for="shortName">Short Name</label>
          <div class="col-md-3"><input class="form-control" maxlength="30" type="text" id="shortName" name="shortName" formControlName="shortName" placeholder="Short Name" /></div>

        </div>

        <div class="row mb-3">
          <label class="col-md-2 form-control-label" for="MaxCharacterLength">Description Length</label>
          <div class="col-md-3"><input class="form-control" maxlength="30" type="number" id="maxCharacterLength" name="maxCharacterLength" formControlName="maxCharacterLength" placeholder="Description Length" /></div>
        </div>

        <div class="row col-md-12">
          <div class="col-md-8"></div>
          <div class="col-md-auto" style="padding-left:29px;">

            <button type="submit" class="btn btn-secondary btn-action pull-right" (click)="BackUrl()" [hidden]="redirectedSectionId!=null || redirectedSurveyId!=null"><i class="fa fa-times"></i> Cancel</button>
            <button type="button" class="btn btn-secondary btn-action pull-right" (click)="BackToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-times"></i> Cancel</button>
            <button type="submit" [disabled]="!questionDescriptionForm.valid" class="btn btn-primary btn-action pull-right" (click)="saveQuestionDescription()"><i class="fa fa-save"></i> Save</button>
          </div>
        </div>
      </form>
    </div>




  </div>
</div>


<ng-template #CreateCategoryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Create Category</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="ResetQuesCategoryForm(); modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="quesCategoryForm" #f="ngForm">
      <div class="row align-items-center">
        <label data-required class="form-control-label col-md-4" for="quesCategoryName">Category <sup class="text-danger">&ast;</sup></label>
        <div class="col-md-8">
          <input class="form-control" type="text" id="quesCategoryName" name="quesCategoryName" formControlName="quesCategoryName" placeholder="Category" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="ResetQuesCategoryForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-primary btn-modal" [disabled]="!quesCategoryForm.valid" (click)="AddQuesCategory(); modal.close()"><i class="fa fa-save"></i> Save</button>
  </div>
</ng-template>

